import { render, staticRenderFns } from "./TenantModule.vue?vue&type=template&id=924037b6"
import script from "./TenantModule.vue?vue&type=script&lang=js"
export * from "./TenantModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports